import { RUN_LEADERBOARD_REPORT, ChurnZeroService } from '../../../../modules/infra/observability/churnzero';
import HttpReports from '../../../httpReports';
import { ERROR, RECEIVE, REQUEST, SET } from './constants';

export const setDashboard = payload => ({ type: SET, payload });

export const fetchDashboard = criteria => (dispatch) => {
  dispatch({ type: REQUEST });
  HttpReports.get(`/shop/${criteria.shopId}/statistics/${criteria.fromDate}/${criteria.toDate}`)
    .then((response) => {
      dispatch({ type: RECEIVE });
      dispatch(setDashboard(response));
      ChurnZeroService.track(RUN_LEADERBOARD_REPORT);
    })
    .catch(() => dispatch({ type: ERROR }));
};
